export default {
  addToken(state, token) {
    state.token = token
  },

  updateAuth(state, res) {
    state.id = res.id
    state.name = res.name
    state.login_id = res.login_id
    state.block = res.block ?? { name: '' }
    state.block_id = res.block_id
    state.email = res.email
    state.company = res.company
    state.avatarPath = res.avatar_path
    state.unread = res.unread
    state.notifications = res.notifications
    state.permission = res.permission
    state.has_approval_authority = res.has_approval_authority
  },

  removeToken(state) {
    state.token = ''
  },
}
